import { useEffect, useState } from "react";
import { ToastMutatorContext } from "./toast.context";
import { IToast, IToastOption, ToastActionType } from "./toast.interface";
import ToastComponent from "../../../components/toast/toast.component";

const ToastContextProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = (value: IToast) => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts((prev) => [...prev, { id, ...value }]);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  useEffect(() => {
    const timeoutIds = toasts.map((toast) => {
      return setTimeout(() => removeToast(toast.id), toast.options.duration || 3000);
    });

    return () => {
      timeoutIds.forEach((id) => clearTimeout(id));
    };
  }, [toasts]);

  return (
    <ToastMutatorContext.Provider value={addToast}>
      {children}
      <ToastComponent toasts={toasts} removeToast={removeToast} />
    </ToastMutatorContext.Provider>
  );
};

export default ToastContextProvider;
